/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import React from 'react';
import { Database, RefreshCw, Loader2, CheckCircle2, AlertTriangle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { cn } from '@/lib/utils';

/** Passo 1 — test della connessione al database. */
export const StepDatabase = ({ dbUrl, onDbUrlChange, onTest, busy, result, currentDbKind }) => (
  <div className="space-y-4 animate-fade-slide" data-testid="setup-panel-db">
    <div>
      <h2 className="font-display font-semibold text-lg flex items-center gap-2"><Database className="h-5 w-5 text-primary" /> Connessione al database privato</h2>
      <p className="text-sm text-muted-foreground">Incolla la connection string PostgreSQL/Supabase per verificarla. Lascia vuoto per testare il database attualmente in uso ({currentDbKind}).</p>
    </div>
    <div>
      <Label>DATABASE_URL (opzionale)</Label>
      <Input value={dbUrl} onChange={(e) => onDbUrlChange(e.target.value)} placeholder="postgresql+asyncpg://postgres:password@db.xxxx.supabase.co:5432/postgres" className="h-11 rounded-xl font-mono text-xs" data-testid="setup-db-url" />
    </div>
    <div className="flex items-center gap-2">
      <Button onClick={onTest} disabled={busy} variant="outline" className="h-11 rounded-xl" data-testid="setup-db-test-btn">{busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <RefreshCw className="h-4 w-4" />} Testa connessione</Button>
      {result && (
        <div className={cn('flex-1 rounded-xl border p-3 text-sm flex items-center gap-2', result.ok ? 'border-success/40 bg-success/5' : 'border-destructive/40 bg-destructive/5')} data-testid="setup-db-result">
          {result.ok ? <CheckCircle2 className="h-4 w-4 text-success" /> : <AlertTriangle className="h-4 w-4 text-destructive" />}
          {result.ok ? <>Connesso a <b>{result.kind}</b> · {result.server_version} · {result.latency_ms} ms</> : <>Errore: {result.error}</>}
        </div>
      )}
    </div>
    <p className="text-[11px] text-muted-foreground">Per usare Postgres in produzione imposta <span className="font-mono">DATABASE_URL</span> nel <span className="font-mono">.env</span> del backend e riavvia: l'adapter <span className="font-mono">db_portable.py</span> farà il resto.</p>
  </div>
);
